// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3qPOE","clinicsSelect":"TableHeading_clinicsSelect__2mFUK"};